import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Building2 } from 'lucide-react';
import { useBrandOrganization } from '@/hooks/useBrandOrganization';

interface LinkToOrganizationModalProps {
  children: React.ReactNode;
}

export const LinkToOrganizationModal: React.FC<LinkToOrganizationModalProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const { linkToOrganization } = useBrandOrganization();

  const handleLink = async () => {
    if (!code.trim()) return;

    setLoading(true);
    try {
      const success = await linkToOrganization(code.trim().toUpperCase());
      if (success) {
        setOpen(false);
        setCode('');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            Join Brand Organization
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Enter the invite code provided by your organization admin to join their team.
          </p>
          
          <div className="space-y-2">
            <Label htmlFor="invite-code">Invite Code</Label>
            <Input
              id="invite-code"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="Enter 8-character code"
              maxLength={8}
              className="font-mono text-lg tracking-wider text-center"
            />
          </div>
          
          <Button 
            onClick={handleLink} 
            disabled={loading || code.length !== 8}
            className="w-full"
          >
            {loading ? "Linking..." : "Join Organization"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};